export enum RESOLUTION {
  BRAND_ALREADY_EXISTS = 'BRAND_ALREADY_EXISTS',
}
